import React, { useEffect } from 'react';
import { useTranslations } from '../../../hooks/useTranslations';
import PanelHeader from '../../ui/PanelHeader/PanelHeader';
import { LayoutTree } from '../DynamicLayout';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarEventComponents,
} from '../../../hooks/Analytics';
import Panel from '../../ui/Panel/Panel';
import { usePageContext } from '../../../hooks/PageContext/usePageContext';
import useOrderTracking from '../../../hooks/useOrderTracking';
import PickupLocationDetails from './components/PickupLocationDetails';
import PickupLocationNotFound from './components/PickupLocationNotFound';

const { FeatureLayout } = LayoutTree;

export interface PickupLocationProps {
  layout?: LayoutTree.FeatureLayout;
  featureName?: string;
  fixedPanelHeight?: string;
}

const PickupLocation = ({
  featureName,
  fixedPanelHeight,
  layout = FeatureLayout.PORTRAIT,
}: PickupLocationProps) => {
  const logEvent = useAnalyticsPost();

  const {
    state: { orderNumbers },
  } = usePageContext();

  const { getCurrentShipment } = useOrderTracking();

  const { locationPanelTitle } = useTranslations();

  useEffect(
    () => {
      const orderNumber = orderNumbers && orderNumbers[0];

      logEvent({
        eventComponent: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
        eventFeature: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
        eventType: NarvarEventTypes.COMPONENT_RENDER,
        feature: featureName,
        orderNumber,
        pageComponent: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
        pageOrderNumber: orderNumber,
        trackLayout: layout,
      });
    },
    // TODO: Make this dependency array exhaustive
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const { pickupLocation } = getCurrentShipment() || {};

  return (
    <Panel
      fixedPanelHeight={fixedPanelHeight}
      sInner={{ padding: 0 }}
      header={<PanelHeader>{locationPanelTitle}</PanelHeader>}
    >
      {pickupLocation ? (
        <PickupLocationDetails
          pickupLocation={pickupLocation}
          layout={layout}
          featureName={featureName}
        />
      ) : (
        <PickupLocationNotFound />
      )}
    </Panel>
  );
};

export default PickupLocation;
